<template>
  <div class="hidden md:flex md:flex-col w-1/3 bg-white"><!--WRAPPER-->
   
    <div v-if="mainStep==0" class="flex flex-col overflow-hidden">
      <div class="relative flex flex-col items-center border border-inbox-primary rounded-lg bg-inbox-mangolia w-full"><!--COL1-->
      <button v-if="detailsEntered" @click="changeMainStep(1)" class="absolute text-inbox-primary top-0 right-1">go to overzicht</button>
        <div class="flex flex-col items-center mt-[3.313rem]">
          <img src="@/assets/images/furniture.png" class="">
          <h3 class="title3 mobile-center mt-10">{{currentOffer.size}} m<sup>3</sup> ({{currentOffer.sizeSquare}}m<sup>2</sup>)</h3>
          <div v-if="!detailsEntered" class="flex flex-col">  
          
            <div class="flex flex-col justify-center mt-2 h-24">
                <p class="text-sm font-bold">Voornaam</p>
                <input v-model="name" placeholder='Jane' v-bind:class="[{ 'inpt': !nameError }, {'inptError': nameError }]">
                <p class="absolute text-sm text-gamma-error md:w-40 lg:w-64 mt-24 p-1" v-if="nameError"><br>{{nameError}}</p>
            </div>    

            <div class="flex flex-col justify-center mt-2 h-24">
              <p class="text-sm font-bold">Telefoonnummer</p>
              <input v-model="phone" placeholder='telefoonnummer' v-bind:class="[{ 'inpt': !phoneError }, {'inptError': phoneError }]">
              <p class="absolute text-sm text-gamma-error md:w-40 lg:w-64 mt-24 p-1" v-if="phoneError"><br>{{phoneError}}</p>
            </div>
          
            <div class="flex flex-col justify-center mt-2 h-24">
              <p class="text-sm font-bold">E-mailadres</p>
              <input v-model="email" placeholder='voorbeeld@gmail.com' v-bind:class="[{ 'inpt': !emailError }, {'inptError': emailError }]">
              <p class="absolute text-sm text-gamma-error md:w-40 lg:w-64 mt-24 p-1" v-if="emailError"><br>{{emailError}}</p>
            </div>

            <div class="flex flex-col justify-center mt-2 h-24">
              <p class="text-sm font-bold">Postcode</p>
              <input ref="zip" v-model="zip" :readonly="$store.state.quotes.length>0" placeholder='1234 AB' v-bind:class="[{ 'inpt': !zipError }, {'inptError': zipError }]">
              <p class="absolute text-sm text-gamma-error md:w-40 lg:w-64 mt-24 p-1" v-if="zipError"><br><br>{{zipError}}</p>
            </div>

            <div class="bg-gamma-green border-2 border-white rounded-3xl flex justify-center py-2 my-6">
              <img src="@/assets/images/calculatorWhite.png" alt="" class="w-5 h-5 my-auto" />
              <button @click="submit()"><p class="text-white md:text-sm lg:text-lg mt-1">Ontdek je prijs</p></button>
            </div>  
        
        
        
          </div><!-- END DETAILS-->
          
        </div>    
        
     </div><!--END COL1-->
    </div>   
    <div v-else class="relative flex flex-col   border rounded-lg border-checkout-mainborder mt-16 overflow-hidden"><!-- QUOTE BOX-->
        <button @click="changeMainStep(0)" class="absolute text-inbox-primary top-0 right-1">go to size details</button>
        <h2 class="chH2 m-6">Overzicht</h2>
        <div class="flex justify-between py-5 px-6 border-t border-checkout-mainborder"><!-- SINGLE QUOTE SECTION-->
          <div class="flex"><!-- NAME AND ICON -->
            <img src="@/assets/images/storage.svg" class="mr-5">
            <span class="chSpan">Opslagruimte</span>
          </div><!--END NAME AND ICON -->
          <div class="flex"><!-- VALUE AND CHANGE BUTTON -->
            <span class="chSpan mr-1">{{submitData.storage_size}} m<sup>3</sup></span>
            <button @click="scrollTo(1)" class="chSpan border-b border-checkout-primary">wijzig</button>
          </div><!--END VALUE AND CHANGE BUTTON --> 

        </div><!-- END SINGLE QUOTE SECTION-->   

        <div class="flex justify-between py-5 px-6 border-t border-checkout-mainborder"><!-- SINGLE QUOTE SECTION-->
          <div class="flex"><!-- NAME AND ICON -->
            <img src="@/assets/images/commitment.svg" class="mr-5">
            <span class="chSpan">Huurperiode</span>
          </div><!--END NAME AND ICON -->
          <div class="flex"><!-- VALUE AND CHANGE BUTTON -->
            <span class="chSpan mr-1">{{getCommitmentTitle(submitData.commitment)}}</span>
            <button @click="scrollTo(2)" class="chSpan border-b border-checkout-primary">wijzig</button>
          </div><!--END VALUE AND CHANGE BUTTON --> 

        </div><!-- END SINGLE QUOTE SECTION-->

         

        <div class="flex justify-between py-5 px-6 border-t border-checkout-mainborder"><!-- SINGLE QUOTE SECTION-->
          <div class="flex"><!-- NAME AND ICON -->
            <img src="@/assets/images/services.svg" class="mr-5">
            <span class="chSpan">Servicepakket</span>
          </div><!--END NAME AND ICON -->
          <div class="flex"><!-- VALUE AND CHANGE BUTTON -->
            <span class="chSpan mr-1">{{getPlan()}} (€{{getPlanPrice()}},00)</span>
            <button @click="scrollTo(3)" class="chSpan border-b border-checkout-primary">wijzig</button>
          </div><!--END VALUE AND CHANGE BUTTON --> 

        </div><!-- END SINGLE QUOTE SECTION-->

        <div class="flex justify-between py-5 px-6 border-t border-checkout-mainborder"><!-- SINGLE QUOTE SECTION-->
          <div class="flex"><!-- NAME AND ICON -->
            <img src="@/assets/images/optional.svg" class="mr-5">
            <span class="chSpan">Opties</span>
          </div><!--END NAME AND ICON -->
          <div class="flex"><!-- VALUE AND CHANGE BUTTON -->
            <span class="chSpan mr-1">{{getTotalES()}} gekozen (€{{getESPrice()}},00)</span>
            <button @click="scrollTo(4)" class="chSpan border-b border-checkout-primary">wijzig</button>
          </div><!--END VALUE AND CHANGE BUTTON --> 

        </div><!-- END SINGLE QUOTE SECTION-->

        <div class="flex justify-between py-5 px-6 border-t border-checkout-mainborder"><!-- SINGLE QUOTE SECTION-->
          <div class="flex"><!-- NAME AND ICON -->
            <img src="@/assets/images/datum.svg" class="mr-5">
            <!--<span class="chSpan">{{getPrefDate()}}</span>-->
            <span class="chSpan">Ophaaldatum</span>
          </div><!--END NAME AND ICON -->
          <div class="flex"><!-- VALUE AND CHANGE BUTTON -->
            <span class="chSpan mr-1">{{getPrefMoment()}} (€{{getPrefMomentPrice()}},00)</span>
            <button @click="scrollTo(5)" class="chSpan border-b border-checkout-primary">wijzig</button>
          </div><!--END VALUE AND CHANGE BUTTON --> 

        </div><!-- END SINGLE QUOTE SECTION-->  

        <div class="flex justify-between py-5 px-6 bg-checkout-light border-t border-checkout-pborder"><!-- TOTAL PRICE SECTION-->
          <div class="flex"><!-- NAME AND ICON -->
            <img src="@/assets/images/datum.svg" class="mr-5">
            <span class="chStrongSpan">Eenmalig</span>
          </div><!--END NAME AND ICON -->
          <div class="flex"><!-- VALUE AND CHANGE BUTTON -->
            <span class="chStrongSpan mr-1">€ {{getPlanPrice()*1 + getESPrice()*1 + getPrefMomentPrice()*1}},00</span>
            
          </div><!--END VALUE AND CHANGE BUTTON --> 

        </div><!-- END TOTAL PRICE-->     

        <div class="flex justify-between py-5 px-6 bg-checkout-light border-t border-checkout-pborder"><!-- PER MONTH PRICE SECTION-->
          <div class="flex"><!-- NAME AND ICON -->
            <img src="@/assets/images/datum.svg" class="mr-5">
            <span class="chStrongSpan">Maandelijks</span>
          </div><!--END NAME AND ICON -->
          <div class="flex"><!-- VALUE AND CHANGE BUTTON -->
            <span class="chStrongSpan mr-1">€{{calculateDiscount(submitData.commitment)}},00</span>
            
          </div><!--END VALUE AND CHANGE BUTTON --> 

        </div><!-- END PER MONTH PRICE-->        
      
    </div><!-- END QUOTE BOX-->    

    <div class="flex items-center bg-checkout-helpbg rounded-xl mt-9 ml-5 p-1">
        <img src="@/assets/images/avatar.png" class="mr-1.5">
        <span class="chSpanHelp"><a href="https://meetings.hubspot.com/bram-meeting-link/gamma-opslagservice" target="_blank"> Hulp nodig met kiezen?</a></span>
    </div>  

    <div class="flex mt-6 ml-5"><!--PHONE NUMBER -->
        <img src="@/assets/images/phone.svg" class="mr-1.5">
        <span class="chPhone">085 - 30 30 880</span>

    </div><!--END PHONE NUMBER -->    

    <div class="flex mt-4 ml-5"><!--PHONE NUMBER -->
        <img src="@/assets/images/mail.svg" class="mr-1.5">
        <span class="chPhone">hallo@inboxstorage.eu</span>

    </div><!--END PHONE NUMBER -->
    <div class="flex flex-col mt-4 ml-5"><!--TRUSTPILOT -->
        <img src="@/assets/images/trustpilot-logo-black.svg" class="w-1/2">
        <span class="italic font-bold mt-2 ml-2">Excellent review score 4.5/5</span>

    </div><!--END TRUSTPILOT -->
    
  </div><!--END WRAPPER-->
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'
import axios from 'axios'
export default {
  data() {
      return {
       first: '',
       last: '',
       size: '',
       category: '',
       name: '',
       nameError: '',
       submitedName: false,
       phone: '',
       phoneCode: '+31',
       phoneError: '',
       submitedPhone: false,
       email: '',
       emailError: '',
       submitedEmail: false,
       zip: '',
       zipError: '',
       submitedZip: '',
       zipRequired: 'no',
       when: 'binnen 1 week',
       distance: '',         
      }
    },//END data()
  computed: {
    ...mapState(['categoryData','submitData','firstLead','ip','firstPage','categoryMobileFlow','currentOffer','categoriesAll','disableHubspot','currentSizeData','mainStep','detailsEntered'])
  },
  methods: {
    ...mapMutations(['changeCategoryData','changeCurrentStep','changeSubmitData','changeFirstLead','editSize','editCategory','setChargeBeeData','setCategoryByName','changeDetailsEntered','changeMainStep']),
    ...mapActions(['renderZip']),
    //globals from nuxt
    validateName(name){
     if(!name || name.length<3){
      return "Voer hier je voornaam in.";
    }
    else
      return "";
    },
    validatePhone(phone){
      let regPhone = /^[()+*#-]*(?:\d[()+*#-]*){7,40}$/;  
    if(phone && !regPhone.test(phone)){
      return "Het telefoonnummer klopt niet.";
    }
    else
      return "";
  
    },
    validateEmail(email){
      let regEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;  
    if(!regEmail.test(email)){
      return "Geef een correct email adres!";
    }
    else
      return "";
    },
    validateZip(zip,required){
      let regZip = /^[1-9][0-9]{3}\s?[a-zA-Z]{2}/;

    if( (zip && required=='yes') && !regZip.test(zip) || zip.length!=6){
      return  "Je postcode moet 4 cijfers en 2 letters bevatten.";
    }
    else
      return  "";
    },
    calculateDiscount(commitment){
      let price = this.currentOffer.price
    if (commitment < 3) 
        return price;
      else if (commitment < 6)
        return Math.round(price * 0.90)
      else if (commitment < 12)
        return Math.round(price * 0.75)
      else if (commitment >= 12)
        return Math.round(price * 0.60)     
    },
    //END from globals
    getCommitmentTitle(commitment){
      if(commitment==1)
        return "1+ maand";
      if(commitment==3)
        return "3+ maanden";
      if(commitment==6)
        return "6+ maanden";
      if(commitment==12)
        return "12+ maanden";
    },
    getPlan(){
      return this.submitData.plan
    },
    getPlanPrice(){
      return this.submitData.planPrice
    },
    getTotalES(){
      return this.submitData.totalES
    },
    getESPrice(){
      return this.submitData.totalESPrice
    },
    getPrefMoment(){
     return this.submitData.prefMoment
    },
    getPrefMomentPrice(){
      return this.submitData.prefMomentPrice
    },
    getPrefDate(){
      return this.submitData.prefDate
    },
    scrollTo(id){
        
      //document.getElementById(id).scrollIntoView();
      const yOffset = 0; 
      const element = document.getElementById(id);
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({top: y, behavior: 'smooth'});  
      }, 
      setNames(){
       this.first = ''
       this.last = '' 
       var tempName 
       if(this.name.includes(' ')){
        tempName = this.name.split(" ");
        this.first = tempName[0]
        tempName.shift();
        for(let i=0;i<tempName.length;i++)
         this.last += tempName[i] + ' '
        this.last=this.last.slice(0, -1)  
        console.log('First name: ' + this.first)
        console.log('Last name: ' + this.last)
        this.changeSubmitData({item:'fname',new:this.first})
        this.changeSubmitData({item:'lname',new:this.last})
       }
       else
        this.changeSubmitData({item:'fname',new:this.name})    
      },
      renderPhone(){
        if (this.phone[0] == '+')
         return;

        if (this.phone[0] == '0'){
          this.changeSubmitData({item:'oldPhone',new:this.phone})
         this.phone = this.phone.substring(1);
        }        
         
        this.phone = this.phoneCode + this.phone

        console.log(this.phone)      

      },
    async submit(){
        this.nameError = ''
        this.phoneError = ''
        this.emailError = ''
        this.zipError = ''
        this.submitedName = true
        this.submitedPhone = true
        this.submitedEmail = true
        this.submitedZip = true
        this.nameError = this.validateName(this.name)
        this.phoneError = this.validatePhone(this.phone)
        this.emailError = this.validateEmail(this.email)
        this.zipError = this.validateZip(this.zip,this.zipRequired)
        if(this.nameError || this.phoneError || this.emailError || (this.zipError && this.zipRequired=='yes'))
         return;
        if(!this.submitData.zip && this.zipRequired == 'no'){
          if(this.zipError)
          this.zip = ''
          else{
            this.renderZip(this.zip)

          }
        }   
        
        this.setNames()
        
        this.changeSubmitData({item:'name',new:this.name})
        this.changeSubmitData({item:'email_address',new:this.email})
        if(this.phone)
          this.renderPhone()
        this.changeSubmitData({item:'phone_number',new:this.phone})

        let hubQuoteCommitmentOne = "1"
        let hubQuoteCommitmentTwo = "3"
        let hubQuoteCommitmentThree = "6"
        let hubQuoteCommitmentFour = "12"
        
        let hubQuotePriceOne = 1
        let hubQuotePriceTwo = 2
        let hubQuotePriceThree = 3
        let hubQuotePriceFour = 4
        //FIRST LEAD CAPTURE
        var hubspotFields = []
       
         hubspotFields = [
            
            {
                'name' : 'firstname',
                'value' : this.name,
            },
            {
                'name' : 'email',
                'value' : this.email,
            },
            {
                'name' : 'phone',
                'value' : this.phone,
            },
            {   'name' : 'aantal_kuub',
                'value' : this.currentOffer.size,
            },
            {   'name' : 'indication_price',
                'value' : this.calculateDiscount(12),
            },
            {
                'name' : 'when_storage_required02',
                'value' : this.when,
            },
            
        ];
         

        let data = {}
        data['context']={
          'pageUri': 'https://inboxstorage.eu/opslagruimte',
          'pageName': 'Personal info',
          
        }
        data['fields']=hubspotFields
        var hslink = ''
        
         hslink = 'https://api.hsforms.com/submissions/v3/integration/submit/1979474/2b4d8223-0fc8-4431-9495-29d330ab1cf1' 
        
          await axios.post(hslink,data)
          .then((response)=>{     
            let res = response.data    
            this.changeFirstLead(true)
            this.changeDetailsEntered(true)
            this.changeMainStep(1)
            
             
          }).catch(error => {
            console.log(error)
          });
        
        //END FIRST LEAD CAPTURE
       
        
       
            this.changeDetailsEntered(true)
            this.changeMainStep(1)
                    
       
      },//END changeCategory()  
  }


}
</script>

<style>

</style>